import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class ClassService {
    private _isBrowser: boolean;
    private _renderer: Renderer2;
    private _ignore: string = " ";
    constructor( @Inject(PLATFORM_ID) private _platformId: Object, rendererFactory: RendererFactory2) {
        this._renderer = rendererFactory.createRenderer(null, null);
        this._isBrowser = isPlatformBrowser(this._platformId);
    }
    // These 2 methods handle when user selects multiple classes separated by space
    // Renderer2.addClass and Renderer2.removeClass support a single class at a time.
    private _hasMultipleClasses(cls: string) {
        return cls.includes(" ") && cls.length > 1;
    }
    private _processMultipleClasses(el: any, spaceSeparatedClasses: string, remove: boolean) {
        let classes: string[] = spaceSeparatedClasses.split(" ");
        classes.forEach((classi: string) => {
            if (!this._ignore.includes(classi))
                (remove) ? this._remove(el, classi) : this._add(el, classi);
        });
    }
    private _add(el: any, cls: string) {
        this._renderer.addClass(el, cls);
    }
    private _remove(el: any, cls: string) {
        if (this._hasClass(el, cls))
            this._renderer.removeClass(el, cls);
    }
    private _hasClass(el: any, cls: string) {
        return el.classList.contains(cls);
    }
    //
    addClass(el: any, cls: string) {
        if (this._hasMultipleClasses(cls))
            this._processMultipleClasses(el, cls, false);
        else
            this._add(el, cls);
    }
    removeClass(el: any, cls: string) {
        if (this._hasMultipleClasses(cls))
            this._processMultipleClasses(el, cls, true);
        else
            this._remove(el, cls);
    }
    clearClass(el: any) {
        if (this._isBrowser && el.className) // Checks if it is a Web browser before accessing DOM
            this.removeClass(el, el.className);
    }
    setClass(el: any, cls: string) {
        this.clearClass(el);
        if (this._isBrowser) { // Checks if it is a Web browser before accessing DOM
            this.addClass(el, cls);
        }
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_services/class.service.ts